module.exports = __webpack_public_path__ + "img/add_teacher.ea186d46.png";